import { render } from "./CandidateProfileExperience.vue?vue&type=template&id=35ffd278&scoped=true"
import script from "./CandidateProfileExperience.vue?vue&type=script&lang=js"
export * from "./CandidateProfileExperience.vue?vue&type=script&lang=js"

import "./CandidateProfileExperience.vue?vue&type=style&index=0&id=35ffd278&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ffd278"]])

export default __exports__